import { useEffect, useState } from 'react';

const ONETRUST_ANALYTICS_GROUP = 'C0004' as const;

const getInitialConsent = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.OnetrustActiveGroups?.includes(ONETRUST_ANALYTICS_GROUP) ?? false
  );
};

export const useAnalyticsConsent = (): boolean => {
  const [hasConsent, setHasConsent] = useState<boolean>(getInitialConsent);

  useEffect(() => {
    const handleConsentUpdate = () => {
      setHasConsent(getInitialConsent());
    };

    window.addEventListener('consent_updated', handleConsentUpdate);

    return () => {
      window.removeEventListener('consent_updated', handleConsentUpdate);
    };
  }, []);

  return hasConsent;
};
